import React from 'react';
import { ClipboardListIcon, ClockIcon, HeartHandshakeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const items = [{
  icon: ClipboardListIcon,
  title: 'El Plan de 72 Horas',
  text: 'Las tres noches, hora por hora: qué hacer, qué evitar y qué esperar en cada una.'
}, {
  icon: ClockIcon,
  title: 'Los Horarios por Edad',
  text: 'Tablas de siestas y ventanas de sueño de 0 a 24 meses, listas para imprimir y pegar en la nevera.'
}, {
  icon: HeartHandshakeIcon,
  title: 'La Guía de Consuelo',
  text: 'Cómo acompañar el llanto sin abandonarlo, con frases y pasos exactos para cada despertar.'
}];
export function WhatYouGet() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="get-title" data-id="element-112" data-mp="190ihg8yz18rj">
      <div className="mx-auto max-w-6xl px-5" data-id="element-113" data-mp="1wqmic8kryueu">
        <div className="mx-auto max-w-2xl text-center" data-id="element-114" data-mp="1worzczt2dcde">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-coral" data-id="element-115" data-mp="21imq2n736rlz">
            Lo que obtienes hoy
          </p>
          <h2 id="get-title" className="mt-3 font-display text-3xl font-black text-slateblue-900 sm:text-4xl" data-id="element-116" data-mp="2vg3mtjgf6ukj">
            Todo el método, en tu teléfono, en menos de 2 minutos
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-117" data-mp="30f6tf8c1t8um">
          {items.map(({
          icon: Icon,
          title,
          text
        }) => <article key={title} className="rounded-2xl border border-slateblue-100 bg-white p-6 shadow-sm" data-id="element-118" data-mp="3e5in3boa7fnv">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-slateblue-50 text-slateblue-600" data-id="element-119" data-mp="399bfleg8lw3t">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-120" data-mp="3j5ob8hvcek17" />
              </span>
              <h3 className="mt-4 font-display text-xl font-bold text-slateblue-900" data-id="element-121" data-mp="1tqgq9qizrq1t">
                {title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-slateblue-600" data-id="element-122" data-mp="1os5gffsp5fjl">
                {text}
              </p>
            </article>)}
        </div>

        <div className="mt-12 grid items-center gap-8 rounded-3xl border border-slateblue-100 bg-white p-6 sm:p-8 lg:grid-cols-2" data-id="element-123" data-mp="2ih4jh5kd88pq">
          <img src="https://cdn.magicpatterns.com/uploads/jcp1xEw1t8cf4sCL37cZYc/ok_ok_ok.png" alt="La guía El Reseteo de Sueño de 72 Horas mostrada en tablet, teléfono y computadora" className="w-full rounded-2xl object-cover" data-id="element-124" data-mp="2nfxvsunx1tob" />
          <div data-id="element-125" data-mp="31fqkkkfvtztn">
            <h3 className="font-display text-2xl font-black text-slateblue-900 sm:text-3xl" data-id="element-126" data-mp="31f7292mbl9f3">
              Léela donde quieras, incluso con el bebé en brazos
            </h3>
            <p className="mt-3 text-[15px] leading-relaxed text-slateblue-600" data-id="element-127" data-mp="3b5s737sl7a6g">
              Formato digital optimizado para móvil, tablet y computadora. Lo
              recibes por correo al instante después de pagar y es tuyo para
              siempre, sin suscripciones ni cargos ocultos.
            </p>
            <div className="mt-6 max-w-sm" data-id="element-128" data-mp="19gcjyo5k1qxv">
              <CtaButton subLabel="Descarga inmediata en tu correo" data-id="element-129" data-mp="19i77894atv54" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}